export const marketDayPageTranslations = {
  nl: {
    title: "Bezoek ons op de markt in Lelystad",
    subtitle: "We kijken ernaar uit u op de markt te zien!",
    marketImageAlt: "AMS Food Market kraam op de zaterdagmarkt in Lelystad centrum",
    when: "Wanneer?",
    whenDetail: "Elke Zaterdag",
    time: "Tijd",
    timeDetail: "08:30 – 16:00",
    location: "Locatie",
    locationDetail: "Markt Lelystad, Agorahof 10-20, 8224 BZ Lelystad",
    locationNote: "U vindt ons naast het loempiakraampje.",
    directions: "Routebeschrijving via Google Maps",
    expectationsTitle: "Wat u kunt verwachten",
    expectationsText: "We brengen een selectie van onze populairste gekookte maaltijden, snacks en verse producten. Het is de perfecte gelegenheid om een snelle, heerlijke hap te nemen of uw favoriete ingrediënten in te slaan.",
    expectationsTag1: "🇮🇳🇱🇰 Sri Lankaanse/Indiase Gerechten",
    expectationsTag2: "🇸🇷 Surinaamse Gerechten",
    expectationsTag3: "Verse Groenten",
    expectationsTag4: "Voedselproducten & Meer",
    selectionImageAlt: "Selectie van gerechten op de marktkraam",
  },
  en: {
    title: "Visit us at the market in Lelystad",
    subtitle: "We look forward to seeing you at the market!",
    marketImageAlt: "AMS Food Market stall at the Saturday market in Lelystad center",
    when: "When?",
    whenDetail: "Every Saturday",
    time: "Time",
    timeDetail: "08:30 AM – 04:00 PM",
    location: "Location",
    locationDetail: "Markt Lelystad, Agorahof 10-20, 8224 BZ Lelystad",
    locationNote: "You will find us next to the spring roll stall.",
    directions: "Directions via Google Maps",
    expectationsTitle: "What You Can Expect",
    expectationsText: "We bring a selection of our most popular cooked meals, snacks, and fresh products. It's the perfect opportunity to grab a quick, delicious bite or stock up on your favorite ingredients.",
    expectationsTag1: "🇮🇳🇱🇰 Sri Lankan/Indian Dishes",
    expectationsTag2: "🇸🇷 Surinamese Dishes",
    expectationsTag3: "Fresh Vegetables",
    expectationsTag4: "Food Products & More",
    selectionImageAlt: "Selection of dishes at the market stall",
  },
};